module.exports = __webpack_public_path__ + "img/308.83489995.png";